// extracted by mini-css-extract-plugin
export default {"logoutBtn":"logout_logoutBtn__YnH1+"};